export default {"src":"/_next/static/media/star_blue.3b6148e1.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};